import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { filter, find } from 'lodash'

import Actions from '../../../../../actions'
import Selectors from '../../../../../selectors'
import Operations from '../../../../../operations'
import { HelpLink, Spinner } from '../../../../../components/generic'
import StockSection from './StockSection'
import {
  EMARInitialAssessmentEmptyState,
  EMARScreenEmptyState,
} from '../components'
import Glyph from '../../../../../LEGACY/Glyph'
import { ButtonOLD, PageHeader } from '@lmc/ui-kit'

import { withRouter } from '../../../../../withRouter'
import { history } from '../../../../../store'
import { isBrowser, isTablet } from 'react-device-detect'

const isDesktop = isBrowser || isTablet

const renderContent = (props) => {
  const { medications, resident, stockItem } = props
  if (!medications) return <Spinner />
  if (!medications.length) {
    return <EMARScreenEmptyState emarOnboarded resident={resident} />
  }
  const icon = stockItem && stockItem.icon
  return (
    <div>
      <StockSection
        title="Scheduled"
        residentId={resident.id}
        icon={icon}
        medications={filter(medications || [], { PRN: false })}
      />
      <StockSection
        title="Not Scheduled (PRN)"
        residentId={resident.id}
        icon={icon}
        medications={filter(medications || [], { PRN: true })}
      />
    </div>
  )
}

export function EMARResidentStockScreen(props) {
  const { fetchData, fetchLogs, home, openModal, resident, user } = props

  const residentId = resident.id

  useEffect(() => {
    if (residentId) {
      fetchData(residentId)
      fetchLogs(residentId)
    }
  }, [residentId])

  const residentName = `${resident.name.first} ${resident.name.last}`
  const isInitialAssessment =
    resident.status === 'pre-assessment' || resident.isActiveInitialAssessment

  return (
    <div style={styles.wrapper}>
      <div style={styles.headerContainer}>
        <PageHeader
          title={`${residentName}'s Medication Stock`}
          sticky
          onBack={!isDesktop ? () => history.back?.() : undefined}
        >
          {user && user.medicationPermission && !isInitialAssessment && (
            <ButtonOLD
              id="add-medication-button"
              onClick={() => openModal(resident.id)}
              style={styles.addMedicationButton}
              type="primary"
              icon={<Glyph name="plus" />}
              disabled={home && !home.features?.emarOnboarded?.enabled}
            >
              Add Medication
            </ButtonOLD>
          )}
        </PageHeader>
        {isInitialAssessment ? (
          <EMARInitialAssessmentEmptyState
            preferredPeopleNominative={home.preferredPeopleNominative}
            resident={resident}
          />
        ) : (
          renderContent(props)
        )}
        {/* <div style={styles.helpLinkContainer}>
          <HelpLink supportLink="https://support.logmycare.co.uk/en/collections/2749236-emar" />
        </div> */}
      </div>
    </div>
  )
}

EMARResidentStockScreen.propTypes = {
  fetchData: PropTypes.func.isRequired,
  fetchLogs: PropTypes.func.isRequired,
  home: PropTypes.object.isRequired,
  medications: PropTypes.array.isRequired,
  openModal: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
  stockItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

const styles = {
  helpLinkContainer: {
    marginTop: 24,
  },
  headerContainer: {},
  helpLink: {
    marginTop: 36,
  },
  wrapper: {
    padding: '0px 0px 48px',
    margin: '0px auto',
    maxWidth: 1080,
  },
}

const mapStateToProps = (state, props) => ({
  home: state.global.home,
  logs: Selectors.populateLogs(state),
  medications: Selectors.getResidentStockCount(state, {
    resident: props.router.params.id,
  }),
  stockItem: find(state.data['log-category-items'], {
    itemId: 'emarStockCount',
  }),
  resident: Selectors.getResidentProfile(state, {
    id: props.router.params.id,
  }),
  stockLogs: filter(state.data.logs || [], { name: 'eMAR Stock Count' }),
  user: Selectors.getCurrentUserProfile(state),
})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (resident) => {
    dispatch(
      Operations.loadList('emar-resident-medications', {
        resident,
        stock: 'true',
      })
    )
    dispatch(Operations.loadList('emar-round-timings'))
  },
  fetchLogs: (resident) => dispatch(Operations.loadList('logs', { resident })),
  openModal: (resident) => {
    dispatch(Operations.openModal({ modalId: 'addEmarMedication' }))
    dispatch(
      Actions.addForm({
        formId: 'addEmarMedication',
        initial: { resident },
      })
    )
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EMARResidentStockScreen)
)
